import api from './api';

export const getProxies = async (params = {}) => {
  const response = await api.get('/proxies/', { params });
  return response.data;
};

export const getProxy = async (id) => {
  const response = await api.get(`/proxies/${id}`);
  return response.data;
};

export const createProxy = async (proxyData) => {
  const response = await api.post('/proxies/', proxyData);
  return response.data;
};

export const updateProxy = async (id, proxyData) => {
  const response = await api.put(`/proxies/${id}`, proxyData);
  return response.data;
};

export const deleteProxy = async (id) => {
  const response = await api.delete(`/proxies/${id}`);
  return response.data;
};

export const autoAssignTokens = async (proxyId) => {
  const response = await api.post(`/proxies/${proxyId}/auto-assign-tokens`);
  return response.data;
};

export const validateProxyTokens = async (proxyId) => {
  const response = await api.get(`/proxies/${proxyId}/validation`);
  return response.data;
};

export const getProxyTokens = async (proxyId) => {
  const response = await api.get(`/proxies/${proxyId}/tokens`);
  return response.data;
};

export const unbindTokenFromProxy = async (tokenId, proxyId) => {
  const response = await api.delete(`/tokens/${tokenId}/bind-proxy/${proxyId}`);
  return response.data;
};